/* ==========================================================================
   RAVEL CUSTOM THEME JAVASCRIPT
   Interactive AJAX Cart Drawer, Cross-sells, Quick Add, PDP Gallery
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initCartDrawer();
  initQuickAdd();
  initAccordions();
  initPdpGallery();
  initVariantPicker();
  initQuantitySteppers();
  initDiscountForms();
  refreshShippingBars();
  initProductSliders();
  initGiftFilters();
  initSoldOutModal();
  initCollectionScroll();
  initCedula();
  initFormsTeaser();
});

/* Forms teaser chip only. The popup keeps the colors set in the Forms app. */
function initFormsTeaser() {
  const paint = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('button').forEach((btn) => {
      const text = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/primera compra/i.test(text) || /registr/i.test(text)) return;
      btn.style.setProperty('background-color', '#641318', 'important');
      btn.style.setProperty('color', '#ffffff', 'important');
      btn.querySelectorAll('*').forEach((el) => {
        el.style.setProperty('color', '#ffffff', 'important');
      });
      btn.querySelectorAll('svg, svg *').forEach((el) => {
        el.style.setProperty('fill', '#ffffff', 'important');
        el.style.setProperty('stroke', '#ffffff', 'important');
      });
    });
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) paint(el.shadowRoot);
    });
  };

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      paint(document);
    });
  };
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
}

/* Regalos: pin "Elige por presupuesto" under the header and reveal the active card in the mobile slider */
function initGiftFilters() {
  const filtros = document.getElementById('filtros');
  if (!filtros) return;

  const activeCard = filtros.querySelector('.price-gift-card.is-active');
  const grid = filtros.querySelector('.price-gift-grid');
  if (grid && activeCard) grid.scrollLeft = Math.max(0, activeCard.offsetLeft - 16);

  const params = new URLSearchParams(window.location.search);
  const hasPrice = params.has('filter.v.price.gte') || params.has('filter.v.price.lte');
  if (location.hash !== '#filtros' && !hasPrice) return;

  const pinFiltros = () => {
    const header = document.querySelector('.site-header');
    const top = window.scrollY + filtros.getBoundingClientRect().top - (header ? header.offsetHeight : 85);
    window.scrollTo(0, Math.max(0, top));
  };
  pinFiltros();
  requestAnimationFrame(pinFiltros);
  window.addEventListener('load', pinFiltros, { once: true });
}

/* Money + Free Shipping Bar */
function formatMoney(cents) {
  return '$' + new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 }).format(Math.round(cents / 100));
}

function renderShippingBars(cart) {
  document.querySelectorAll('[data-shipping-bar]').forEach(bar => {
    const threshold = Number(bar.getAttribute('data-threshold'));
    if (!threshold) return;
    const total = cart.total_price;
    const remaining = threshold - total;
    const pct = Math.min(100, Math.floor((total * 100) / threshold));

    bar.classList.toggle('is-hidden', cart.item_count === 0);
    bar.classList.toggle('is-complete', remaining <= 0);

    const title = bar.querySelector('[data-shipping-title]');
    const hint = bar.querySelector('[data-shipping-hint]');
    const amounts = bar.querySelector('[data-shipping-amounts]');
    const fill = bar.querySelector('[data-shipping-fill]');
    const track = bar.querySelector('[role="progressbar"]');

    if (title) title.textContent = remaining <= 0 ? '¡YA TIENES ENVÍO GRATIS!' : `TE FALTAN ${formatMoney(remaining)} PARA ENVÍO GRATIS`;
    if (hint) hint.textContent = remaining <= 0 ? 'Tu pedido califica para envío gratis.' : 'Agrega un producto más para desbloquearlo';
    if (amounts) amounts.textContent = `${formatMoney(total)} / ${formatMoney(threshold)}`;
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', pct);
  });
}

async function refreshShippingBars() {
  if (!document.querySelector('[data-shipping-bar]')) return;
  try {
    const res = await fetch('/cart.js');
    renderShippingBars(await res.json());
  } catch (e) {
    console.error(e);
  }
}

/* Discount code: stored with /discount/CODE and applied automatically at checkout */
function initDiscountForms() {
  document.querySelectorAll('[data-discount-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('[data-discount-input]');
      const msg = form.querySelector('[data-discount-msg]');
      const code = input.value.trim();
      if (!code) return;

      msg.className = 'discount-field__msg';
      try {
        const res = await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
        if (!res.ok) throw new Error(res.status);
        msg.textContent = `Cupón ${code.toUpperCase()} guardado. Se aplicará al finalizar la compra.`;
        msg.classList.add('is-success');
      } catch (err) {
        msg.textContent = 'No pudimos guardar el cupón. Inténtalo de nuevo.';
        msg.classList.add('is-error');
      }
    });
  });
}

/* Mobile Navigation */
function initMobileNav() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const closeBtn = document.querySelector('[data-mobile-drawer-close]');
  const overlay = document.querySelector('[data-mobile-drawer-overlay]');

  if (!toggle || !drawer) return;

  function openMenu() {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/* Cart Drawer */
function initCartDrawer() {
  const triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');

  if (!drawer) return;

  window.openCartDrawer = function(showAlert = false) {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    const alertBanner = document.querySelector('[data-cart-alert]');
    if (alertBanner) {
      alertBanner.style.display = showAlert ? 'flex' : 'none';
    }
    updateCartDrawer();
  };

  window.closeCartDrawer = function() {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  };

  triggers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.openCartDrawer(false);
  }));

  closeBtns.forEach(btn => btn.addEventListener('click', window.closeCartDrawer));
  if (overlay) overlay.addEventListener('click', window.closeCartDrawer);
}

/* Quick Add to Cart via AJAX */
function initQuickAdd() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    let quantity = 1;
    const qtyInput = btn.closest('form')?.querySelector('input[name="quantity"]');
    if (qtyInput) quantity = Math.max(1, Number(qtyInput.value) || 1);

    const originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Agregando...</span>';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
      });

      if (response.ok) {
        btn.innerHTML = '<span>¡Agregado!</span>';
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 1200);

        if (window.openCartDrawer) window.openCartDrawer(true);
        updateCartCount();
      } else {
        const err = await response.json();
        alert(err.description || 'Error al agregar al carrito');
        btn.innerHTML = originalText;
        btn.disabled = false;
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      btn.innerHTML = originalText;
      btn.disabled = false;
    }
  });
}

/* Update Cart Drawer Contents */
async function updateCartDrawer() {
  const container = document.querySelector('[data-cart-items-container]');
  const subtotalElem = document.querySelector('[data-cart-subtotal]');
  if (!container) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    renderShippingBars(cart);

    document.querySelectorAll('addi-widget[data-addi-cart]').forEach(el => {
      el.setAttribute('price', String(Math.round(cart.total_price / 100)));
    });

    if (cart.item_count === 0) {
      container.innerHTML = '<p style="text-align: center; color: #666; padding: 40px 0;">Tu bolsa de compras está vacía.</p>';
      if (subtotalElem) subtotalElem.textContent = '$0';
      return;
    }

    let html = '';
    cart.items.forEach((item, index) => {
      const priceFormatted = formatMoney(item.final_line_price);
      const sku = item.sku ? String(item.sku).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char])) : '';
      html += `
        <div class="cart-drawer__item" data-line-key="${item.key}">
          <img src="${(item.featured_image && item.featured_image.url) || ''}" alt="${item.title}" class="cart-drawer__item-img">
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-title">${item.product_title}</div>
            ${sku ? `<div class="cart-drawer__item-sku">Ref. ${sku}</div>` : ''}
            <div class="cart-drawer__item-sub">${item.variant_title ? item.variant_title : 'Diseño colombiano'}</div>
            <div class="cart-drawer__item-price">${priceFormatted}</div>
            <div class="cart-drawer__item-controls">
              <div class="cart-drawer__stepper">
                <button type="button" onclick="changeCartLineQty('${item.key}', ${item.quantity - 1})">—</button>
                <span>${item.quantity}</span>
                <button type="button" onclick="changeCartLineQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <button type="button" class="cart-drawer__item-remove" onclick="changeCartLineQty('${item.key}', 0)">Eliminar</button>
            </div>
          </div>
        </div>
      `;
    });

    container.innerHTML = html;
    if (subtotalElem) {
      subtotalElem.textContent = formatMoney(cart.total_price);
    }
  } catch (e) {
    console.error('Error fetching cart:', e);
  }
}

window.changeCartLineQty = async function(lineKey, newQty) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Number(newQty) })
    });
    updateCartDrawer();
  } catch (e) {
    console.error('Error updating cart line:', e);
  }
};

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
    renderShippingBars(cart);
  } catch (e) {
    console.error(e);
  }
}

/* Accordions */
function initAccordions() {
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      if (!content) return;
      const isOpen = content.style.display === 'block';
      content.style.display = isOpen ? 'none' : 'block';
      trigger.classList.toggle('active', !isOpen);
    });
  });
}

/* PDP Gallery: horizontal carousel */
function initPdpGallery() {
  const root = document.querySelector('[data-pdp-carousel]');
  const track = document.querySelector('[data-pdp-track]');
  if (!root || !track) return;
  const slides = track.querySelectorAll('.pdp-carousel__slide');
  const thumbs = Array.from(document.querySelectorAll('[data-pdp-thumb]'));
  if (!slides.length) return;

  let index = 0;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;
    thumbs.forEach((btn, i) => btn.classList.toggle('active', i === index));
  };
  root.showSlide = show;
  if (slides.length < 2) return;

  root.querySelector('[data-pdp-prev]')?.addEventListener('click', () => show(index - 1));
  root.querySelector('[data-pdp-next]')?.addEventListener('click', () => show(index + 1));
  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => show(Number(btn.getAttribute('data-pdp-thumb'))));
  });

  let startX = null;
  root.addEventListener('pointerdown', (e) => { startX = e.clientX; });
  root.addEventListener('pointerup', (e) => {
    if (startX == null) return;
    const dx = e.clientX - startX;
    startX = null;
    if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
  });
}

/* Product options: match the clicked values to a variant and update price, reference, and buy buttons. */
function initVariantPicker() {
  const dataEl = document.getElementById('ProductVariants');
  const form = document.querySelector('.pdp-form');
  if (!dataEl || !form) return;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }
  if (!variants.length) return;

  const groups = Array.from(form.querySelectorAll('[data-option-index]'));
  if (!groups.length) return;

  const priceEl = document.querySelector('[data-pdp-price]');
  const compareEl = document.querySelector('[data-pdp-compare]');
  const saleEl = document.querySelector('[data-pdp-sale]');
  const skuEl = document.querySelector('[data-pdp-sku]');
  const noteEl = document.querySelector('[data-pdp-variant-note]');
  const idInput = form.querySelector('input[name="id"]');
  const buttons = form.querySelectorAll('[data-variant-id]');

  const selectedValues = () => groups.map((group) => {
    const active = group.querySelector('.pdp-pill.active');
    return active ? active.getAttribute('data-option-value') : '';
  });

  const findVariant = (values) => variants.find((variant) =>
    variant.options.every((option, index) => option === values[index])
  );

  const apply = () => {
    const values = selectedValues();

    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('.pdp-pill').forEach((pill) => {
        const candidate = values.slice();
        candidate[groupIndex] = pill.getAttribute('data-option-value');
        const match = findVariant(candidate);
        pill.classList.toggle('is-unavailable', !match || !match.available);
      });
    });

    const variant = findVariant(values);
    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    buttons.forEach((btn) => {
      btn.setAttribute('data-variant-id', variant.id);
      btn.disabled = !variant.available;
    });
    if (priceEl) priceEl.textContent = variant.price;
    if (compareEl) {
      const onSale = variant.compare_cents > variant.price_cents;
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? variant.compare : '';
    }
    if (saleEl) saleEl.hidden = !(variant.compare_cents > variant.price_cents);
    if (skuEl) {
      const sku = variant.sku || '';
      skuEl.hidden = !sku;
      skuEl.textContent = sku ? `Ref. ${sku}` : '';
    }
    if (noteEl) noteEl.hidden = variant.available;

    if (variant.image_id) {
      const slides = Array.from(document.querySelectorAll('.pdp-carousel__slide'));
      const slide = slides.find((item) => item.getAttribute('data-media-id') === String(variant.image_id));
      const carousel = document.querySelector('[data-pdp-carousel]');
      if (slide && carousel && typeof carousel.showSlide === 'function') {
        carousel.showSlide(slides.indexOf(slide));
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState({}, '', url);
  };

  const options = form.querySelector('[data-pdp-options]');
  if (!options) return;
  options.addEventListener('click', (event) => {
    const pill = event.target.closest('.pdp-pill');
    if (!pill) return;
    event.preventDefault();
    event.stopPropagation();
    const group = pill.closest('[data-option-index]');
    group.querySelectorAll('.pdp-pill').forEach((el) => {
      const selected = el === pill;
      el.classList.toggle('active', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    apply();
  });
}

/* PDP Quantity Stepper */
function initQuantitySteppers() {
  document.querySelectorAll('[data-qty-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const change = Number(btn.getAttribute('data-qty-change'));
      let val = Number(input.value) + change;
      if (val < 1) val = 1;
      input.value = val;
    });
  });
}

/* Product slider dots (mobile carousels) */
function initProductSliders() {
  document.querySelectorAll('[data-product-slider]').forEach(slider => {
    const dots = slider.parentElement.querySelector('[data-slider-dots]');
    const cards = Array.from(slider.children);
    if (!dots || cards.length < 2) return;

    dots.innerHTML = '';
    const buttons = cards.map((card, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'slider-dots__dot';
      b.tabIndex = -1;
      b.addEventListener('click', () => slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft - parseFloat(getComputedStyle(slider).paddingLeft), behavior: 'smooth' }));
      dots.appendChild(b);
      return b;
    });

    const update = () => {
      const max = slider.scrollWidth - slider.clientWidth;
      let active = 0;
      if (max > 0 && slider.scrollLeft >= max - 4) {
        active = cards.length - 1;
      } else {
        const start = cards[0].offsetLeft;
        let best = Infinity;
        cards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - start - slider.scrollLeft);
          if (d < best) { best = d; active = i; }
        });
      }
      buttons.forEach((b, i) => b.classList.toggle('is-active', i === active));
    };

    slider.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

function initSoldOutModal() {
  const modal = document.querySelector('[data-sold-out-modal]');
  if (!modal) return;

  const nameEl = modal.querySelector('[data-sold-out-name]');
  const detailEl = modal.querySelector('[data-sold-out-detail]');
  let previousOverflow = '';

  const close = () => {
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
  };

  const open = (url, name) => {
    nameEl.textContent = name || 'Este producto';
    detailEl.href = url || '#';
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;
    modal.querySelector('.sold-out-modal__dialog').focus();
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.product-card--sold-out');
    if (!card || event.target.closest('.product-card__wishlist-btn')) return;
    event.preventDefault();
    open(card.getAttribute('data-product-url'), card.getAttribute('data-product-title'));
  });

  modal.querySelectorAll('[data-sold-out-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) close();
  });
}

/* Cédula: required before checkout, stored on the order as attribute Cedula */
function initCedula() {
  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cedula-checkout]');
    if (!control || control.getAttribute('aria-disabled') === 'true') return;

    const scope = control.closest('[data-cedula-scope]');
    const input = scope && scope.querySelector('[data-cedula-input]');
    const errorEl = scope && scope.querySelector('[data-cedula-error]');
    if (!input) return;

    event.preventDefault();
    const digits = input.value.replace(/\D/g, '');
    const message = !digits
      ? 'Ingresa tu cédula de ciudadanía.'
      : (digits.length < 6 || digits.length > 10)
        ? 'La cédula debe tener entre 6 y 10 números.'
        : '';

    if (message) {
      input.setAttribute('aria-invalid', 'true');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = message;
      }
      input.focus();
      return;
    }

    input.value = digits;
    input.removeAttribute('aria-invalid');
    if (errorEl) errorEl.hidden = true;
    control.setAttribute('aria-disabled', 'true');

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { Cedula: digits } })
      });
      if (!response.ok) throw new Error(String(response.status));
      window.location.href = '/checkout';
    } catch (error) {
      control.removeAttribute('aria-disabled');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'No pudimos guardar la cédula. Inténtalo de nuevo.';
      }
    }
  });
}

/* Collection grid: load the next page of products as the list reaches the bottom */
function initCollectionScroll() {
  const more = document.querySelector('[data-collection-more]');
  const grid = document.querySelector('[data-collection-grid]');
  const nextLink = more && more.querySelector('[data-collection-next]');
  if (!more || !grid || !nextLink) return;

  document.querySelectorAll('[data-collection-pagination]').forEach((pagination) => pagination.remove());
  more.hidden = false;
  nextLink.hidden = true;

  const status = more.querySelector('[data-collection-status]');
  let loading = false;
  let observer;

  const showFallback = () => {
    loading = false;
    if (status) status.textContent = '';
    nextLink.hidden = false;
    nextLink.removeAttribute('aria-disabled');
    if (observer) observer.disconnect();
  };

  const loadNext = async () => {
    if (loading || !more.isConnected) return;
    const url = nextLink.getAttribute('href');
    if (!url) return;

    loading = true;
    if (observer) observer.unobserve(more);
    if (status) status.textContent = 'Cargando más productos…';
    nextLink.setAttribute('aria-disabled', 'true');

    try {
      const fetchUrl = new URL(url, window.location.origin);
      const sectionId = more.getAttribute('data-section-id');
      if (sectionId) fetchUrl.searchParams.set('section_id', sectionId);
      const res = await fetch(fetchUrl.toString());
      if (!res.ok) throw new Error(String(res.status));

      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nextGrid = doc.querySelector('[data-collection-grid]');
      if (!nextGrid) throw new Error('grid');

      const cards = Array.from(nextGrid.querySelectorAll(':scope > .product-card'));
      if (!cards.length) throw new Error('empty');
      cards.forEach((card) => grid.appendChild(document.importNode(card, true)));

      const incoming = doc.querySelector('[data-collection-next]');
      const incomingHref = incoming && incoming.getAttribute('href');
      if (incomingHref) {
        nextLink.setAttribute('href', incomingHref);
        nextLink.hidden = true;
        nextLink.removeAttribute('aria-disabled');
        loading = false;
        if (status) status.textContent = '';
        if (observer) observer.observe(more);
      } else {
        more.remove();
        if (observer) observer.disconnect();
      }
    } catch (error) {
      showFallback();
    }
  };

  nextLink.addEventListener('click', (event) => {
    event.preventDefault();
    nextLink.hidden = true;
    loadNext();
  });

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNext();
    }, { rootMargin: '600px 0px' });
    observer.observe(more);
  } else {
    nextLink.hidden = false;
  }
}
